import { useState } from "react";
import {useAuthContext} from './useAuthContext';


 export const useEditProfile = () =>{
    const[error,setError] = useState(null)
    const[isLoading, setIsLoading] = useState(null)
    const {user} = useAuthContext()



    const editProfile = async(firstname, lastname) =>{
        setIsLoading(true)
        setError(null)

        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/update-info`, {
            method: 'PATCH',
            headers: {'Content-Type':'application/json', 
            'Authorization': `Bearer ${user}`
        },
            body: JSON.stringify({firstname, lastname})
        })
        const json = await response.json()
        if(response.status === 401){
          
        
           }else{
        if(!response.ok){
            setIsLoading(false)
            setError(json.error)
        } 

        if(response.ok){
            return json
        }
           }
    }

    return {editProfile,isLoading,error}
 }

 